import { render, staticRenderFns } from "./DiscoverTripPlan.vue?vue&type=template&id=0b0a1e94&scoped=true"
import script from "./DiscoverTripPlan.vue?vue&type=script&lang=ts"
export * from "./DiscoverTripPlan.vue?vue&type=script&lang=ts"
import style0 from "./DiscoverTripPlan.vue?vue&type=style&index=0&id=0b0a1e94&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0a1e94",
  null
  
)

export default component.exports